module.exports = __webpack_public_path__ + "media/images/result_sets/icons/learned_icon-ed1526a1baf86890ea1cf02b626fdac7.svg";